import { AiOutlineInfoCircle } from "react-icons/ai";
import { ErrorBox } from "./common/ErrorBox";
import { useFormContext } from "react-hook-form";

export const YesNoPicker = ({
  name,
  label,
  title,
  detailed_label,
  validation,
  errors,
}) => {
  const { register } = useFormContext();

  return (
    <div className={`space-y-2`}>


      <div className="flex justify-between">

<h1 className="text-2xl uppercase text-blue-600 font-semibold ">{title}</h1>

<AiOutlineInfoCircle className="text-blue-600 text-xl" />
</div>
      <div className="h-auto bg-red flex justify-start mb-2">
        <div className="flex items-center h-5">
          <input
            type="checkbox"
            {...register(name, validation)}
            id="opmeting"
            className="w-4 h-4 border border-gray-300 rounded bg-gray-50 focus:ring-3 focus:ring-blue-300 dark:bg-gray-700 dark:border-gray-600 dark:focus:ring-blue-600 dark:ring-offset-gray-800"
          />
        </div>
        <label
          htmlFor="opmeting"
          className="ms-2 text-sm font-medium text-gray-900 "
        >
          {detailed_label}
        </label>
      </div>
    </div>
  );
};
